/* eslint-disable arrow-body-style */
import { mapActions, mapGetters, mapState } from 'vuex';
import { flatten, sumBy } from 'lodash';
import marketListItemExpandableSushi, { OFFSET_CHECK_TIMEOUT } from '@/components/market/market-list-item-expandable-sushi/market-list-item-expandable-sushi.vue';
import { contractOwnershipNum } from '@/utils/helpers';
import contentLoaderMixin from '@/mixins/contentLoader';
import loaderMixin from '@/mixins/loader';
import constants from '@/constants';
import scrollTo from '@/utils/scrollTo';
import { MODALS } from '@/components/app/app-modals/modals-constants';

const MY_SHARES_INITIAL = 0.0;

export default {
  mixins: [
    contentLoaderMixin,
    loaderMixin
  ],
  components: {
    marketListItemExpandableSushi,
  },
  props: {
    sushi: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isLoading: true,
      toggledItems: [],
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    ...mapState('dashboard', ['myShares', 'marketsToggle']),
    ...mapState('popup', ['currentPopup']),
    ...mapState('trade', ['tradeOptions']),
    marketsNumber() {
      return (this.myShares) ? this.myShares.markets.length : 0;
    },
    marketsShares() {
      const markets = (this.myShares && this.myShares.markets) ? this.myShares.markets : [];
      return markets.reduce(
        (previous, current) => {
          const userQuantity = sumBy(current.marketContracts, i => i.userQuantity);
          return previous + userQuantity;
        }, MY_SHARES_INITIAL);
    },
    filteredMarkets() {
      const markets = (this.myShares && this.myShares.markets) ? this.myShares.markets : [];
      const statuses = [
        constants.MARKET_SETTLED,
      ];
      return markets
        .filter(m => !statuses.includes(m.status))
        .filter(m => sumBy(m.marketContracts, i => contractOwnershipNum(i)) > 0);
    },
    filteredMarketsContractsIds() {
      return flatten(this.filteredMarkets.map(market => market.marketContracts))
        .filter(i => contractOwnershipNum(i) > 0)
        .map(i => i.contractId);
    },
    showMarketsList() {
      return this.marketsNumber > 0;
    },
    showNoSharesPlaceholder() {
      return this.marketsNumber === 0 && !this.isLoading;
    },
  },
  methods: {
    ...mapActions('dashboard', ['getMyShares', 'setDashboardOpen']),
    ...mapActions('popup', ['setCurrentPopup']),
    ...mapActions('trade', ['setTradeOptions', 'setBottomBetSlipExtendedMode']),
    isItemExpanded(marketId) {
      const item = this.toggledItems.find(i => i.marketId === marketId);
      return !!item;
    },
    isExpandingAllTriggered(marketId) {
      const item = this.toggledItems.find(i => i.marketId === marketId) || {};
      return item.expandAll;
    },
    onMarketListItemToggle(data) {
      if (data.expanded) {
        this.toggledItems.push({
          marketId: data.market.marketId,
          expandAll: false,
        });
      } else {
        this.toggledItems = [
          ...this.toggledItems.filter(i => i.marketId !== data.market.marketId),
        ];
      }
    },
    scrollToMarketsSection() {
      setTimeout(() => {
        const elOffset = this.$refs.myshares.offsetTop;
        const offset = this.isLayoutMobile ? elOffset - 45 : elOffset - 95;
        scrollTo(offset, 500);
      }, OFFSET_CHECK_TIMEOUT);
    },
  },
  watch: {
    marketsToggle(value) {
      if (value) {
        this.toggledItems = this.filteredMarkets.map((i) => {
          return {
            marketId: i.marketId,
            expandAll: true,
          };
        });
        // this.scrollToMarketsSection();
      } else {
        this.toggledItems = [];
      }
    },
    filteredMarketsContractsIds() {
      if (
        this.currentPopup === MODALS.PURCHASE &&
        this.tradeOptions &&
        this.tradeOptions.contractId &&
        !this.filteredMarketsContractsIds.includes(this.tradeOptions.contractId)
      ) {
        this.setCurrentPopup();
        this.setTradeOptions(null);
      }
    },
  },
  created() {
    this.loaderAdd(document.body);
    this.getMyShares()
      .then(() => {
        this.loaderRemove(document.body);
        this.isLoading = false;
        this.isComponentReady = true;
      })
      .catch(() => {
        this.loaderRemove(document.body);
        this.isLoading = false;
      });
  },
  beforeDestroy() {
    this.setTradeOptions(null);
    this.setBottomBetSlipExtendedMode(false);
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/portfolio-my-markets/portfolio-my-markets.js